import React from "react";
import { isEmpty } from "lodash";

import { OnlineLink, Tooltip, SupportLevelIcon, Mid } from "components";
import { getFullName } from "helpers";
import { TsysFileTypes } from "types";

import styles from "../search.module.scss";

export const terminalResultItem = (obj): { [key: string]: any } => {
	return (
		<div className={`${styles.wrappSearchInfo} flex-wrap`}>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Terminal Solution #:</p>
					{obj?.number && obj?.merchant_id ? (
						<OnlineLink
							to={`/merchant/list/info/${obj?.merchant_id}/terminal-solutions/${obj?.id}/edit`}
							target="_blank"
							style={{ marginLeft: "15px" }}
						>
							TS - {obj?.number}
						</OnlineLink>
					) : (
						<Tooltip
							title={"Terminal is in TID & Equipment request."}
							disabled={!obj?.number}
						>
							<span style={{ marginLeft: "15px" }}>
								{obj?.number && `TS - ${obj?.number}`}
							</span>
						</Tooltip>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>App ID:</p>
					{obj?.application_id && (
						<OnlineLink
							to={`applications/${obj?.application_id}/get-started`}
							target="_blank"
							style={{ marginLeft: "15px" }}
						>
							{obj?.application?.number}
						</OnlineLink>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>MID:</p>
					{obj?.merchant ? (
						<p className="ml-3 d-flex">
							<SupportLevelIcon name={obj?.priority_type} />
							<OnlineLink
								to={`/merchant/list/info/${obj?.merchant?.id}/general`}
								target="_blank"
								style={{ marginLeft: "7px" }}
							>
								<Mid merchant={obj?.merchant} />
							</OnlineLink>
						</p>
					) : (
						obj?.application && (
							<>
								<p className="ml-3 d-flex">
									<SupportLevelIcon
										name={obj?.priority_type}
									/>
									<p className={styles.content}>
										<Mid merchant={obj?.application} />
									</p>
								</p>
							</>
						)
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>DBA Name:</p>
					<p className={`break-word ${styles.content}`}>
						{obj?.merchant?.dba_name ?? obj?.application?.dba_name}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent Office & Agent:</p>
					<div className={styles.content}>
						{obj.agent_office_id && obj?.agent_office && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-office-setup/edit-agent-office/${obj.agent_office_id}/general-info`}
									target="_blank"
								>
									{obj?.agent_office?.name}
								</OnlineLink>
							</p>
						)}
						{obj?.agent_id && obj?.agent && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-setup/edit-agent/${obj?.agent_id}/general-info`}
									target="_blank"
								>
									{getFullName(obj?.agent)}
								</OnlineLink>
							</p>
						)}
					</div>
				</div>
			}
			{obj?.is_terminal && (
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Manufacturer / Model:</p>
					<p className={styles.content}>
						{obj.manufacturer} {obj.manufacturer && "/"} {obj.model}
					</p>
				</div>
			)}
			{obj?.is_gateway && (
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Gateway:</p>
					<p className={styles.content}>{obj.gateway}</p>
				</div>
			)}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>TID:</p>
					<p className={styles.content}>{obj?.tid}</p>
				</div>
			}
			{obj?.is_terminal && (
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>SIM #:</p>
					<p className={styles.content}>{obj?.sim_number}</p>
				</div>
			)}
			{obj?.is_gateway && (
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Gateway ID:</p>
					<p className={styles.content}>{obj?.gateway_id}</p>
				</div>
			)}
			{obj?.is_point_of_sale && obj?.point_type === 2 && (
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>TSYS File Type:</p>
					<p className={styles.content}>
						{TsysFileTypes.getDisplayName(obj?.tsys_file_type)}
					</p>
				</div>
			)}
			{obj?.is_point_of_sale && obj?.point_type === 2 && (
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Product Name:</p>
					<p className={styles.content}>{obj?.tsys_product_name}</p>
				</div>
			)}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Front end MID:</p>
					<p className={styles.content}>{obj?.front_end_mid}</p>
				</div>
			}
			{!isEmpty(obj?.terminal?.terminal_devices) &&
				obj?.terminal?.terminal_devices?.map(devices => (
					<div className={styles.searchInfoSection} key={devices?.id}>
						<p
							className={styles.labelTitle}
						>{`Serial # (${devices.type_name}):`}</p>
						<p className={styles.content}>
							{devices?.serial_number}
						</p>
					</div>
				))}
			{obj?.terminal?.terminal_accessories &&
				obj?.terminal?.terminal_accessories.map((accessory, index) => (
					<div
						className={styles.searchInfoSection}
						key={accessory.id}
					>
						<p
							className={styles.labelTitle}
						>{`Serial # (Accessory ${index + 1}):`}</p>
						<p className={styles.content}>
							{accessory?.serial_number}
						</p>
					</div>
				))}
		</div>
	);
};
